import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Table,
} from 'reactstrap';
import { Field } from 'redux-form';
import Panel from '../../../../../shared/components/Panel';
import renderSelectField from '../../../../../shared/components/form/Select';
import {
  OptionShape,
  typeOptions,
  statusOptions,
  editRoleOptions,
  viewRoleOptions,
} from './utils';
import {
  getTableHeaderStyle,
  getTableRowStyle,
  getTableWrapperStyle,
  isDarkTheme,
} from '../../../../../shared/helpers/themeTableStyles';

export default function AddSettingPanel({
  initialLoad, getData, dynamicValueField, groups, onCreate, onReset,
}) {
  const theme = useSelector(store => store.theme);
  const isDarkMode = isDarkTheme(theme);
  const rowStyle = getTableRowStyle(isDarkMode, false);

  return (
    <Panel lg={12} title="Add New Setting" getData={getData} parentRefresh={initialLoad}>
      <div style={getTableWrapperStyle(isDarkMode)}>
        <Table responsive className="table--bordered">
          <thead style={{ backgroundColor: isDarkMode ? '#232531' : '#f8f9fa' }}>
            <tr>
              <th style={getTableHeaderStyle(isDarkMode)}>#</th>
              <th style={getTableHeaderStyle(isDarkMode)}>Key</th>
              <th style={getTableHeaderStyle(isDarkMode)}>Value</th>
              <th style={getTableHeaderStyle(isDarkMode)}>Type</th>
              <th style={getTableHeaderStyle(isDarkMode)}>Status</th>
              <th style={getTableHeaderStyle(isDarkMode)}>Edit Role</th>
              <th style={getTableHeaderStyle(isDarkMode)}>View Role</th>
              <th style={getTableHeaderStyle(isDarkMode)}>Group</th>
              <th style={getTableHeaderStyle(isDarkMode)}>Update</th>
              <th style={getTableHeaderStyle(isDarkMode)}>Create</th>
              <th style={getTableHeaderStyle(isDarkMode)}>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr style={rowStyle}>
              <td style={rowStyle}>NEW</td>
              <td style={rowStyle}>
                <span className="form">
                  <Field
                    name="newKey"
                    component="input"
                    className="form"
                  />
                </span>
              </td>
              <td style={rowStyle}>
                <span className="form">
                  {dynamicValueField('newValue', 'new', null)}
                </span>
              </td>
              <td style={rowStyle}>
                <Field
                  name="newType"
                  component={renderSelectField}
                  type="text"
                  options={typeOptions}
                />
              </td>
              <td style={rowStyle}>
                <Field
                  name="newStatus"
                  component={renderSelectField}
                  type="text"
                  options={statusOptions}
                />
              </td>
              <td style={rowStyle}>
                <Field
                  name="newEditRole"
                  component={renderSelectField}
                  type="text"
                  options={editRoleOptions}
                />
              </td>
              <td style={rowStyle}>
                <Field
                  name="newViewRole"
                  component={renderSelectField}
                  type="text"
                  options={viewRoleOptions}
                />
              </td>
              <td style={rowStyle}>
                <Field
                  name="newGroup"
                  component={renderSelectField}
                  type="text"
                  options={groups}
                />
              </td>
              <td style={rowStyle}>auto</td>
              <td style={rowStyle}>auto</td>
              <td style={rowStyle}>
                <button type="button" className="badge badge-success badge-btn" onClick={() => onCreate(0)}>Create</button>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <button type="button" className="badge badge-warning badge-btn" onClick={() => onReset(0)}>Reset</button>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </Panel>
  );
}

AddSettingPanel.propTypes = {
  initialLoad: PropTypes.bool.isRequired,
  getData: PropTypes.func.isRequired,
  dynamicValueField: PropTypes.func.isRequired,
  groups: PropTypes.arrayOf(PropTypes.shape(OptionShape)).isRequired,
  onCreate: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};
